import { Component } from '@angular/core';
import { ViewController, LoadingController, ToastController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users/users-service';
import { User } from '../../models/user';
import { UserEmailExistsValidator } from '../../validators/user-email-exists';

@IonicPage()
@Component({
  selector: 'page-create-user-modal',
  templateUrl: 'create-user-modal.html',
})
export class CreateUserModalPage {
  public User: User;
  public userForm: FormGroup;
  public isCordova: boolean;
  public selectOptions: any = { cssClass: null };

  ionViewDidLoad() {

    // Define custom select classes if
    // not in mobile env.
    this.selectOptions.cssClass = this.isCordova ? null : 'extra-wide';
  }

  save(userForm) {
    let u: string;

    for(u in userForm)
    {
      if(userForm[u] === this.User.get(u))
      {
        delete userForm[u];
      }
    }

    if(Object.keys(userForm).length === 0)
    {
      return this.close();
    }

    let loading = this.loadingCtrl.create({
      content: "Saving..."
    });

    loading.present();

    let self: CreateUserModalPage = this;
    this.usersService.create(userForm)
      .subscribe(
        res => {
          loading.dismiss();

          self.User = new User(res);

          let toast = this.toastCtrl.create({
            message: `${self.User.get("name")}'s account was successfully updated.`,
            duration: 6000,
            position: "top"
          });

          toast.present();

          self.close();
        },
        rej => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: rej.error.message,
            duration: 8000,
            position: "top"
          });

          toast.present();
        }
      );
  }

  close() {
    this.viewCtrl.dismiss(this.User);
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  constructor(private viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    private emailExistsValidator: UserEmailExistsValidator,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private platform: Platform,
    private usersService: UsersService
    ) {

      // Identify if this is browser or device.
      this.isCordova = this.platform.is('cordova');

      this.User = new User();

      this.userForm = this.formBuilder.group({
          name: [ '',
                  Validators.compose([Validators.minLength(8), Validators.maxLength(120), Validators.pattern(/^[a-zA-Z\s\-]*$/), Validators.required])
                ],
          email:[ '',
                  Validators.compose([Validators.required]),
                  this.emailExistsValidator.excludeId(this.User.get("id")).checkEmail.bind(this.emailExistsValidator)
                ],
          role: [ '',
                  Validators.compose([Validators.required])
                ],
          password: [ '',
                  Validators.compose([Validators.required])
                ],
          password_confirmation: [ '',
                  Validators.compose([Validators.required])
                ]
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/create-user-modal/create-user-modal.ts